import tw, { styled } from 'twin.macro'

import { mobile } from '@flowwai-frontend/shared/utils/web'
export const TaskLoadingWrapper = styled.div`
   width: 240px;
   -webkit-transition: all 300ms ease-in-out;
   transition: all 300ms ease-in-out;
   border-top: 4px solid #ccc9c9;
   --bg-opacity: 1;
   background-color: rgba(255, 255, 255, var(--bg-opacity));
   margin: 0;
   box-sizing: border-box;
   border-radius: 0.25rem;
   margin: 8px 16px;
   border-radius: 6px;
`
export const HomeBoardLoadingWrapper = styled.div`
   display: flex;
   flex-wrap: wrap;
   ${mobile} {
      justify-content: center;
   }
`
export const AssigneeAndIdLoadingWrapper = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
`
export const Header = styled.div`
   background-color: #eee;
   width: 100%;
   ${mobile} {
      height: 24px;
      padding: 4px;
      z-index: 15;
   }
   height: 16px;
   ${tw`overflow-hidden flex top-0`};
`
export const ContentLoader = styled.div`
   padding: 12px 16px 4px;
`
